import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the PWA service worker so the app is installable ("Add to Home
// Screen") and loads fast. It never caches /api or POSTs, so data stays live.
//
// Auto-update: installed PWAs (mobile + desktop) must pick up new deploys WITHOUT
// a reinstall or manual cache clear. We watch the build manifest CRA emits
// (/asset-manifest.json) — its hashed main.js path changes on every deploy. When
// the live hash differs from the one we booted with, a new version is out, so we
// refresh the service worker and reload the page once.
if ("serviceWorker" in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      let bootedBundle = null;

      const liveBundle = async () => {
        try {
          const r = await fetch("/asset-manifest.json", { cache: "no-store" });
          const m = await r.json();
          return (m.files && m.files["main.js"]) || null;
        } catch { return null; }
      };

      const check = async () => {
        const live = await liveBundle();
        if (!live) return;                       // offline / unreachable: do nothing
        if (bootedBundle === null) { bootedBundle = live; return; }
        if (live !== bootedBundle && !reloading) {
          reloading = true;
          try { await reg.update(); } catch { /* ignore */ }
          window.location.reload();
        }
      };

      check();                                   // capture the version we booted with
      setInterval(check, 5 * 60 * 1000);         // re-check every 5 min
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
      });
    }).catch(() => { /* ignore */ });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
